import { render, staticRenderFns } from "./editComment.vue?vue&type=template&id=94b6e40e&scoped=true&"
import script from "./editComment.vue?vue&type=script&lang=js&"
export * from "./editComment.vue?vue&type=script&lang=js&"
import style0 from "./editComment.vue?vue&type=style&index=0&id=94b6e40e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b6e40e",
  null
  
)

export default component.exports